import * as React from 'react';
import { Col } from 'reactstrap';
import { IGlobalContextProps, withGlobalContext } from 'src/context/global.context';
import { ProfileNavLink } from './ProfileNavLink';

interface IProjectNavProps {
  pathname: string;
}

export const ProfileNav: React.SFC<IProjectNavProps & IGlobalContextProps> = ({
  context,
  pathname,
}) => {
  const isActive = (currentPathname: string) => {
    return currentPathname === pathname;
  };

  return (
    <Col
      md={2}
      className='d-flex flex-column justify-content-between align-items-center p-3 border border-top-0 border-bottom-0 border-left-0'
      style={{ fontFamily: 'Fredoka One', fontSize: '16px' }}
    >
      <div className='w-100'>
        {context.user && context.user.type === 'consultant' && (
            <ProfileNavLink
              isActive={isActive('')}
              label='Mon profil'
              pathname=''
              src='user'
            />
          )}
        <ProfileNavLink
          isActive={isActive('contact/')}
          label='Coordonnées'
          pathname='contact/'
          src='contact'
        />
        <ProfileNavLink
          isActive={isActive('password/')}
          label='Mot de passe'
          pathname='password/'
          src='password'
        />
      </div>
      <div className='mb-5 w-100'>
        <ProfileNavLink
          isActive={isActive('delete/')}
          isLast={true}
          label='Suppression compte'
          pathname='delete/'
          src='user-delete'
        />
      </div>
    </Col>
  );
};

export const ProfileNavWithGlobalContext = withGlobalContext(ProfileNav);



// WEBPACK FOOTER //
// ./src/components/Profile/ProfileNav/ProfileNav.tsx